import moment from "moment";
import React from  "react";



const transactionLinksActionClicked = 
  (item, key) => async (event) => {
    event.stopPropagation();
    if (key === "contact" && item.contactId)
      window.open(
        `/home/Contacts-CRM/contact-profile-edit?formType=${2}&id=${
          item.contactId
        }`,
        "_blank"
      );
  };

export const ClientsTrackingTableHeaderData = (t) => [
  {
    id: 1,
    label: "service-id",
    input: "serviceId",
    searchableKey: "serviceId",
    isSortable: false ,
    isHiddenFilter: false,
    fieldType: "number",
    textInputMin: 0 , 
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.serviceId || ""}</div>,
    textInputType : 'number' , 
    positiveNumber : true ,
  },
  {
    id: 2,
    label: "service-name",
    input: "serviceName",
    searchableKey: "serviceName",
    isSortable: false ,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.serviceName || ""}</div>,
  },
  {
    id: 3,
    label: "client-id",
    input: "contactId",
    searchableKey: "contactId",
    isSortable: false ,
    isHiddenFilter: false,
    isDefaultFilterColumn: true,
    isNumber: true,
    fieldType: "number",
    textInputType : 'number' , 
    positiveNumber : true  , 
    textInputMin: 0 ,
    component: (item) =>
      item.contactId ? (
        <a
          className="c-primary newTabActivites"
          onClick={transactionLinksActionClicked(item, "contact")}
        >
          {item.contactId || "N/A"}
        </a>
      ) : (
        <span> {item.contactId || ""} </span>
      ),
    
  },
  {
    id: 4,
    label: "client-name",
    input: "contactName",
    searchableKey: "contactName",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) =>
      item.contactId ? (
        <a
          className="c-primary newTabActivites"
          onClick={transactionLinksActionClicked(item, "contact")}
        >
          {item.contactName || "N/A"}
        </a>
      ) : (
        <span> {item.contactName || ""} </span>
      ),
  },
  {
    id: 5,
    label: "creation-on",
    input: "createdOn",
    isHiddenFilter: false,
    fieldKey: "createdOn",
    displayPath: "createdOn",
    fieldType: "alt-date",
    isDefaultFilterColumn: true,
    isDate: true,
    isSortable: true,
    component: (item) => (
      <div>
        {(item?.createdOn &&
          moment(item?.createdOn).format("DD/MM/YYYY - hh:mm A")) ||
          ""}
      </div>
    ),
  },
  {
    id: 6,
    label: "vendor-id",
    input: "vendorId",
    searchableKey: "vendorId",
    isNumber: true,
    fieldType: "number",
    isSortable: false ,
    isHiddenFilter: false,
    fieldType: "number",
    textInputMin: 0 ,
    textInputType : 'number' , 
    positiveNumber : true   ,
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.vendorId || ""}</div>,
  },
  {
    id: 7,
    label: "vendor-name",
    input: "VendorName",
    searchableKey: "VendorName",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.vendorName || ""}</div>,
  },
  {
    id: 8,
    label: "service-category",
    input: "vendorServiceCategoryName",
    searchableKey: "vendorServiceCategoryName",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.vendorServiceCategoryName || ""}</div>,
  },
  {
    id: 9,
    label: "psi-commission-percentagete",
    input: "psiCommissionPercentage",
    searchableKey: "psiCommissionPercentage",
    isSortable: true,
    isHiddenFilter: false,
    isNumber: true,
    fieldType: "number",
    textInputType : 'number' , 
    positiveNumber : true , 
    textInputMin: 0 , 
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.psiCommissionPercentage || ""}</div>,
  },
  {
    id: 10,
    label: "vendor-offer",
    input: "vendorOfferName",
    searchableKey: "vendorOfferName",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.vendorOfferName || ""}</div>,
  },
  {
    id: 11,
    label: "transaction-amount",
    input: "transactionAmount",
    searchableKey: "transactionAmount",
    isSortable: true,
    isHiddenFilter: false,
    isNumber: true,
    fieldType: "number",
    textInputMin: 0 , 
    isNumber: true,
    textInputType : 'number' , 
    positiveNumber : true  ,
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.transactionAmount || ""}</div>,
  },
  {
    id: 12,
    label: "psi-commission-status",
    input: "psiCommissionStatusName",
    searchableKey: "psiCommissionStatusName",
    isSortable: false ,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.psiCommissionStatusName || ""}</div>,
  },
  {
    id: 13,
    label: "discount-percentage",
    input: "discountPercentage",
    searchableKey: "discountPercentage",
    isSortable: false ,
    isHiddenFilter: false,
    fieldType: "number",
    isNumber: true,
    textInputMin: 0 , 
    textInputMax : 100 ,
    textInputType : 'number' , 
    positiveNumber : true  , 
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.discountPercentage || ""}</div>,

  },
  {
    id: 14,
    label: "invoice-number",
    input: "invoiceId",
    searchableKey: "invoiceId",
    isSortable: true,
    isHiddenFilter: false,
    isNumber: true,
    fieldType: "number",
    textInputMin: 0 , 
    textInputType : 'number' , 
    positiveNumber : true   , 
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.invoiceId || ""}</div>,
  },{
    id: 15,
    label: "transaction-status",
    input: "transactionStatusName",
    searchableKey: "transactionStatusName",
    isSortable: true,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.transactionStatusName || ""}</div>,
  },

  {
    id: 16,
    label: "client-feedback",
    input: "clientFeedback",
    searchableKey: "clientFeedback",
    isSortable: false ,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.clientFeedback || ""}</div>,
  },
  {
    id: 17,
    label: "qr-code",
    input: "qrCode",
    searchableKey: "qrCode",
    isSortable: false ,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.qrCode || ""}</div>,
  },
  {
    id: 18,
    label: "promo-code",
    input: "promoCode",
    searchableKey: "promoCode",
    isSortable: false ,
    isHiddenFilter: false,
    fieldType: "text",
    isDefaultFilterColumn: true,
    component: (item) => <div>{item?.promoCode || ""}</div>,
  },

];
